import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCartComponent } from './product-cart/product-cart.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { TranslateModule } from '@ngx-translate/core';
import { CardButtonsComponent } from 'src/app/components/card-buttons/card-buttons.component';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { VendedorRespuestaComentariosComponent } from '../../product-detail/components/vendedor-respuesta-comentarios/vendedor-respuesta-comentarios.component';
import { PagueloFacilComponent } from './paguelo-facil/paguelo-facil.component';
import { ChangeCoinComponent } from './change-coin/change-coin.component';
import { PagoMovilComponent } from './pago-movil/pago-movil.component';

const declarations = [
  ProductCartComponent,
  CardButtonsComponent,
  VendedorRespuestaComentariosComponent,
  PagueloFacilComponent,
  ChangeCoinComponent,
  PagoMovilComponent,
];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    TranslateModule,
    DirectivesModule,
    GeneralesComponentsModule,
  ],
  exports: declarations,
})
export class ComponentsCompraModule {}
